import BudgetPhaseMetaDateTimeRange from "./BudgetPhaseMetaDateTimeRange";
import {
  toCampaignRunRangeInput,
  type CampaignRunRangePickerProps,
} from "./phaseDateTimeRangeModel";

export type { CampaignRunRangePickerProps };

/**
 * Campaign run start/end (minute-level event wall, no Meta UTC snap).
 * Requires a parent {@link LocalizationProvider}.
 */
export function CampaignRunRangePicker(props: CampaignRunRangePickerProps) {
  return <BudgetPhaseMetaDateTimeRange {...toCampaignRunRangeInput(props)} />;
}
